import React from "react";

function NotFound() {
  return (
    <>
      <h1>Cette page n'existe pas :)</h1>
    </>
  );
}

export default NotFound;
